// @ts-check

import React, { useState } from 'react';
import { func, object, string } from 'prop-types';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { VisibilityIcon, VisibilityOffIcon } from 'components/icons';

/**
 * @component ProfileEditorPwdField
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.name
 * @param {"small"|"medium"} props.size
 * @param {string} props.value
 * @param {EditorValidType} props.valid
 * @param {(name:string, payload: any) => void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorPwdField({ label, name, size, value, valid, onHandle }) {
	const [show, setShow] = useState(false);

	return (
		<TextField
			fullWidth
			variant="outlined"
			InputLabelProps={{ shrink: true }}
			type={show ? 'text' : 'password'}
			required
			size={size}
			name={name}
			label={label}
			value={value}
			error={valid.hasErr}
			helperText={valid.msg}
			onChange={(e) => onHandle(name, e.target.value)}
			autoComplete="new-password"
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton onClick={() => setShow(!show)}>
							{show ? <VisibilityIcon /> : <VisibilityOffIcon />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
}

ProfileEditorPwdField.propTypes = {
	label: string,
	name: string,
	size: string,
	value: string,
	valid: object,
	onHandle: func,
};

export default ProfileEditorPwdField;
